import { useState } from 'react';
import { faqs } from '@/mocks/homeData';

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map((f) => ({
    '@type': 'Question',
    name: f.q,
    acceptedAnswer: { '@type': 'Answer', text: f.a },
  })),
};

export default function Faq() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="scroll-mt-20 bg-background-50 py-16 md:py-24">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }} />
      <div className="mx-auto max-w-4xl px-4 md:px-6">
        <div className="text-center">
          <span className="text-sm font-semibold tracking-widest text-primary-600">疑难解答</span>
          <h2 className="mt-2 font-heading text-3xl font-black text-foreground-950 md:text-4xl">
            常见问题<span className="text-primary-600">一次说清</span>
          </h2>
          <p className="mx-auto mt-3 max-w-xl text-base text-foreground-600 md:text-lg">
            关于蹲瓜时间表、蹲守提醒和热度榜的疑问，这里都有答案。
          </p>
        </div>

        <div className="mt-10 space-y-3">
          {faqs.map((f, i) => {
            const isOpen = open === i;
            return (
              <div
                key={f.q}
                className={`overflow-hidden rounded-xl border transition ${
                  isOpen ? 'border-primary-200 bg-primary-50/50' : 'border-background-200 bg-background-100/50'
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? null : i)}
                  aria-expanded={isOpen}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left md:px-6"
                >
                  <span className="flex items-center gap-3">
                    <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-lg text-sm ${isOpen ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-700'}`}>
                      <i className="ri-question-line" />
                    </span>
                    <span className={`font-heading font-bold ${isOpen ? 'text-primary-800' : 'text-foreground-900'}`}>
                      {f.q}
                    </span>
                  </span>
                  <i
                    className={`ri-add-line shrink-0 text-xl transition-transform duration-300 ${isOpen ? 'rotate-45 text-primary-600' : 'text-foreground-400'}`}
                  />
                </button>
                {isOpen && (
                  <div className="px-5 pb-5 pl-[4.75rem] text-sm leading-relaxed text-foreground-600 md:px-6 md:pl-20 md:text-base">
                    {f.a}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}